import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IDomainDependenciesErrorModal {
  isOpen: boolean;
  isErrorModalMinimized: boolean;
  data: {
    domainInheritances: any[];
    domainRelations: any[];
    questionReferences: any[];
  };
}

const defaultData: IDomainDependenciesErrorModal['data'] = {
  domainInheritances: [],
  domainRelations: [],
  questionReferences: [],
};

export const initialState: IDomainDependenciesErrorModal = {
  isOpen: false,
  isErrorModalMinimized: false,
  data: defaultData,
};

const domainDependenciesErrorModalSlice = createSlice({
  name: 'domainDependenciesErrorModal',
  initialState,
  reducers: {
    setDomainDepModalIsOpen: (state, action: PayloadAction<boolean>) => {
      state.isOpen = action.payload;
    },
    setDomainDepModalMinimized: (state, action: PayloadAction<boolean>) => {
      state.isErrorModalMinimized = action.payload;
    },
    setDomainDepData: (state, action: PayloadAction<IDomainDependenciesErrorModal['data']>) => {
      state.data = action.payload;
    },
    closeDomainDepModal: (state) => {
      state.isOpen = false;
      state.isErrorModalMinimized = false;
      state.data = defaultData;
    },

    launchDependenciesErrorModal: (
      state,
      action: PayloadAction<{
        domainInheritances: any[];
        domainRelations: any[];
        questionReferences: any[];
      }>
    ) => {
      state.data = action.payload;
      state.isOpen = true;
      state.isErrorModalMinimized = false;
    },
  },
});

export const {
  setDomainDepModalIsOpen,
  setDomainDepModalMinimized,
  setDomainDepData,
  closeDomainDepModal,
  launchDependenciesErrorModal,
} = domainDependenciesErrorModalSlice.actions;

export default domainDependenciesErrorModalSlice.reducer;
